import './App.css'
import 'antd-notifications-messages/lib/styles/style.css'

import React from 'react'
import { Provider } from 'react-redux'
import { Router } from 'react-router-dom'

import Initializer from '@/components-latest/primitives/Initializer/Initializer'
import { Toaster } from '@/components-latest/ui/Toaster'
import history from '@/config/router/history'
import RouteManager from '@/config/router/RouteManager'
import store from '@/config/store/store'
const App = () => {
  return (
    <Provider store={store}>
        <Router history={history as any}>
        <Toaster />
        <Initializer />
        <RouteManager />
      </Router>
    </Provider>
  )
}

export default App
